module.exports = __webpack_public_path__ + "img/ic-ic-my-list-empty.e059c02c.svg";